// src/shared/telemetry/TimeWindowPills.tsx
// ────────────────────────────────────────────────────────────────────────────
// Pill-group time-window selector — shared across all telemetry dashboards.
// PAC Glass design system.
// ────────────────────────────────────────────────────────────────────────────

import React from 'react'
import type { TimeWindow } from './types'

export interface TimeWindowPillsProps {
  windows: readonly TimeWindow[]
  active: TimeWindow
  onChange: (tw: TimeWindow) => void
  /** 'pill' = rounded pill group (DaemonOps), 'bar' = segmented bar (IoT). */
  variant?: 'pill' | 'bar'
}

export default function TimeWindowPills({ windows, active, onChange, variant = 'pill' }: TimeWindowPillsProps) {
  if (variant === 'bar') {
    return (
      <div className="flex rounded-md overflow-hidden border border-white/[0.06]">
        {windows.map(tw => (
          <button
            key={tw.label}
            onClick={() => onChange(tw)}
            className={`px-2.5 py-1 text-[10px] font-semibold tracking-wider uppercase transition-colors
              ${tw.label === active.label
                ? 'bg-white/[0.08] text-neutral-100'
                : 'text-neutral-500 hover:text-neutral-300 hover:bg-white/[0.04]'}`}
          >
            {tw.label}
          </button>
        ))}
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1 pac-glass rounded-full px-1 py-0.5">
      <span className="text-[10px] uppercase tracking-wider text-neutral-500 px-1.5">Window</span>
      {windows.map(tw => (
        <button
          key={tw.label}
          onClick={() => onChange(tw)}
          className={`text-[11px] px-2 py-0.5 rounded-full transition-colors ${
            tw.label === active.label
              ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/40'
              : 'text-neutral-500 hover:text-neutral-300 border border-transparent'
          }`}
        >
          {tw.label}
        </button>
      ))}
    </div>
  )
}
